import React from 'react';
import { useSelector } from 'react-redux';
import { TimePicker } from 'ui-components/components/time-picker';
import Global from '../../../../store/global-selectors';
import { DateService } from '../../../../services/date-service';
import sharedStyles from '../shared-styles.module.less';

/**
 * @param {object} props
 * @param {string} [props.value] - The selected time value
 * @param {(selectedTime: string) => void} props.onChange - Callback when time is selected
 */
export const OrderImportTimeInput = ({ value = '', onChange }) => {
  const userTimeFormat = useSelector(Global.selectUserUserTimeFormat);
  const isTwelveHour = DateService.isTwelveHourFormat(userTimeFormat);
  const timeFormat = isTwelveHour ? 'h:mm a' : 'HH:mm';

  return (
    <TimePicker
      className={sharedStyles.menu}
      id='order-import-time-input'
      minuteIncrementUnit={30}
      onTimeSelected={onChange}
      selectedValue={value}
      timeFormat={timeFormat}
    />
  );
};
